import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { PreferencesProvider } from "./contexts/PreferencesContext";
import { DateRangeProvider } from "./contexts/DateRangeContext";
import { TrialProvider } from "./contexts/TrialContext";
import theme from "./theme";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://2f909f0a0735a0dc7dd94770a6c63412@o4509427818627072.ingest.de.sentry.io/4509427821314128",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0, // Lower in production
  });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DateRangeProvider>
        <PreferencesProvider>
          <TrialProvider>
            <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
              <App />
            </Sentry.ErrorBoundary>
          </TrialProvider>
        </PreferencesProvider>
      </DateRangeProvider>
    </ThemeProvider>
    ,
  </React.StrictMode>
);
